import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';
import Auth from '../services/auth.js';
import AppInsights from './AppInsights.js';
import FacilityDataAccess from '../services/facilityDataAccess.js';
import ENTSystemDataAccess from '../services/entSystemDataAccess.js';
import FormControl from '@material-ui/core/FormControl';
import { InputLabel } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import ProgressIndicator from './ProgressIndicator.js';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { BlobServiceClient, BlobItem } from "@azure/storage-blob";

const entSystemDataAccess = new ENTSystemDataAccess();
const auth = new Auth();

const styles = theme => ({
    root: theme.mixins.gutters({
        paddingTop: 16,
        paddingBottom: 16,
        marginTop: theme.spacing(1),
    }),
    inputLabel: {
        paddingLeft: 2,
        marginLeft: 18,
        marginTop: -10,
        width: '100%',
    },
    formControl: {
        width: '100%',
        paddingLeft: 5,
    },
});

class ENTWizard extends Component {

    displayName = ENTWizard.name

    constructor(props) {
        super(props);

        // Initial state
        this.state = {
            data: [],
            isLoading: false,
            entReports: [{
                ReportDisplayName: "ENT_Dataload",
                ReportFileName: "ENT_Dataload.xlsx",
                AllowedFileTypes: ".xlsx",
                ReportDetails: "ENT_Dataload File",
                AllowMultipleFiles: false,
                SelectedFile: null,
                SelectedFiles: []
            }],
            blobStorageClient: null,
            workflow: null,
            period: "",
            year: ""
        };
        this.gridRef = React.createRef();

    }

    componentDidMount() {
        // Fetch blob storage URL from the database
        this.fetchBlobStorageUrl();
    }

    handleError = (error) => {
        // Log the error to Application Insights
        AppInsights.trackException({ exception: error });
    };

    fetchBlobStorageUrl() {
        var self = this;
        try {
            entSystemDataAccess.getENTSettings().then(function (settings) {
                if (settings) {
                    const blobStorageUrl = settings.BlobService;

                    const blobServiceClient = new BlobServiceClient(blobStorageUrl);

                    self.setState({ blobStorageClient: blobServiceClient });
                } else {
                    self.handleError('Error fetching Blob Storage URL: -URL not defined');
                }
            });
        } catch (error) {
            self.handleError('Error fetching Blob Storage URL: -' + error);
        }

    };

    onPeriodChange = () => event => {
        this.setState({ period: event.target.value });
    }

    onYearChange = () => event => {
        this.setState({ year: event.target.value });
    }

    // Upload selected ENT files to Azure Storage
    uploadENTFiles = async () => {
        var self = this;

        self.setState({ isLoading: true });
        try {
            // Check if entReports or Reports is undefined before proceeding
            if (!self.state.entReports) {
                self.handleError('entReports or Reports is undefined.');
                self.setState({ isLoading: false });
                return;
            }


            // Check if any selected file has an extension not allowed
            const invalidFiles = self.state.entReports.filter(report => {

              // Check if the selected file has an invalid extension
              return report.SelectedFile && !self.isFileExtensionAllowed(report.SelectedFile.name, report.AllowedFileTypes);
                
            });

            if (invalidFiles.length > 0) {
                // Display an alert if any selected file has an extension not allowed
                window.alert(`File extension not allowed for the following reports:\n${invalidFiles.map(report => report.ReportDisplayName).join('\n')}`);
                self.setState({ isLoading: false });
                return;
            }
            // Construct the ContainerClient
            let containerName = 'entdataload';
            
            var containerClient = self.state.blobStorageClient.getContainerClient(containerName);

            let uploadedFiles = { data: [] };

            // Use for...of loop to handle asynchronous tasks properly
            for (const report of self.state.entReports) {

                if ((report.AllowMultipleFiles && report.SelectedFiles.length > 0) || (!report.AllowMultipleFiles && report.SelectedFile)) {

                    const selectedFiles = report.AllowMultipleFiles ? report.SelectedFiles : [report.SelectedFile];

                    for (let index = 0; index < selectedFiles.length; index++) {
                        const selectedFile = selectedFiles[index];


                        // Extract file name and extension from ReportFileName
                        const [fileName, fileExtension] = report.ReportFileName.split('.');

                        selectedFile.finalFileName = report.ReportFileName;
                        
                        // Construct the blob name by appending the report file name to the directory path
                        var blobName = `${selectedFile.finalFileName}`;

                        var blobClient = containerClient.getBlockBlobClient(blobName);

                        const options = {
                            blobHTTPHeaders: {
                                blobContentType: selectedFile.type
                            }
                        };

                        try {
                            // Upload the file to Azure Storage
                            await blobClient.uploadBrowserData(selectedFile, options);

                           
                            // Add the uploaded file details to the list
                            uploadedFiles.data.push({
                                Id: "ENTWizard_" + selectedFile.finalFileName,
                                Name: selectedFile.finalFileName,
                                Displayfile_name: selectedFile.finalFileName,
                                Path: "ENTWizard/" + blobName,
                                LastModified: selectedFile.lastModifiedDate,
                                Size: selectedFile.size,
                                MediaType: selectedFile.type,
                                IsFolder: false,
                                ETag: "",
                                FileLocator: "",
                                LastModifiedBy: null,
                                period: self.state.period,
                                year: self.state.year
                            });
                            

                        } catch (error) {
                            console.log(error);
                            self.handleError('Error uploading file: -' + error);
                            // Display an alert in case of upload failure
                            window.alert('Error uploading files. Please try again.');
                            self.setState({ isLoading: false });
                            return;
                        }
                    }
                }
            }

            // Reset the file input after successful upload
            const fileInputs = document.querySelectorAll('input[type="file"]');
            fileInputs.forEach(input => input.value = null);

            // Generate a JSON file with the list of uploaded files
            const jsonContent = JSON.stringify(uploadedFiles, null, 2);
            const jsonblobName = '/entwizard.json';
            const jsonBlobClient = containerClient.getBlockBlobClient(jsonblobName);

            try {
                // Upload the JSON file to Azure Storage
                await jsonBlobClient.uploadBrowserData(jsonContent, { blobHTTPHeaders: { blobContentType: 'application/json' } });
            } catch (error) {
                console.log(error);
                self.handleError('Error uploading JSON file: -' + error);
                // Display an alert in case of JSON file upload failure
                window.alert('Error uploading JSON file. Please try again.');
                self.setState({ isLoading: false });
                return;
            }

            // Display a success message when all files are successfully uploaded
            window.alert('All files uploaded successfully!');
        } catch (error) {
            console.log(error);
            self.handleError('Error uploading files: -' + error);
            window.alert('Error uploading files. Please try again.');
            self.setState({ isLoading: false });
            return;
        }
        self.setState({ isLoading: false });
    };

    // Function to check if the file extension is allowed
    isFileExtensionAllowed = (fileName, allowedFileTypes) => {
        if (allowedFileTypes === '*') {
            // If AllowedFileTypes is '*', any file type is allowed
            return true;
        }

        const fileExtension = fileName.split('.').pop().toLowerCase(); // Get the lowercase file extension
        const allowedExtensions = allowedFileTypes.split(',').map(ext => ext.trim().toLowerCase().replace('.', '')); // Convert allowed extensions to lowercase and remove '.'

        return allowedExtensions.includes(fileExtension);
    };

    render() {

        const { classes } = this.props;

        const columnDefs = [];
        const defaultColDef = { resizable: true };

        const currentYear = new Date().getFullYear();
        const years = Array.from({ length: 50 }, (_, i) => currentYear - i);

        return (
            <div>
                {/*Progress indicator component*/}

                <ProgressIndicator showProgressIndicator={this.state.isLoading} progressTitle={'Please wait...'} progressText={'Loading data...'} />
                <h2>ENT Wizard</h2>
                <Grid container className={classes.root} spacing={2}>
                    <Grid item xs={3}>
                        <Grid container className={classes.root} spacing={3}>
                            <Grid item xs={12}>
                                <FormControl className={classes.formControl}>
                                    <InputLabel id="Year" className={classes.inputLabel}>Year</InputLabel>
                                    <Select
                                        value={this.state.year || ''}
                                        onChange={this.onYearChange()}
                                        id="Year"
                                        labelId="Year"
                                        variant="outlined"
                                        margin="dense"
                                        label="Year"
                                        fullWidth
                                        MenuProps={{
                                            anchorOrigin: {
                                                vertical: "bottom",
                                                horizontal: "left"
                                            },
                                            transformOrigin: {
                                                vertical: "top",
                                                horizontal: "left"
                                            },
                                            getContentAnchorEl: null
                                        }}
                                    >
                                        {years.map(year => (
                                            <MenuItem key={year} value={year}>{year}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl className={classes.formControl}>
                                    <InputLabel id="Period" className={classes.inputLabel}>Period</InputLabel>
                                    <Select
                                        value={this.state.period || ''}
                                        onChange={this.onPeriodChange()}
                                        id="Period"
                                        labelId="Period"
                                        variant="outlined"
                                        margin="dense"
                                        label="Period"
                                        fullWidth
                                        MenuProps={{
                                            anchorOrigin: {
                                                vertical: "bottom",
                                                horizontal: "left"
                                            },
                                            transformOrigin: {
                                                vertical: "top",
                                                horizontal: "left"
                                            },
                                            getContentAnchorEl: null
                                        }}
                                    >
                                        {[...Array(12).keys()].map(month => (
                                            <MenuItem key={month + 1} value={String(month + 1).padStart(2, '0')}>
                                                {String(month + 1).padStart(2, '0')}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={8}>
                        <div><TableContainer component={Paper}>
                            <Table className={classes.table} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Report Name</TableCell>
                                        <TableCell>File Format</TableCell>
                                        <TableCell align="right">Report Parameters</TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.entReports && this.state.entReports.length > 0 ? (
                                        this.state.entReports.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell component="th" scope="row">
                                                    {row.ReportDisplayName}
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {row.AllowedFileTypes}
                                                </TableCell>
                                                <TableCell align="right">
                                                    <div dangerouslySetInnerHTML={{ __html: row.ReportDetails.replace(/;/g, '<br />') }} />
                                                </TableCell>
                                                <TableCell align="right" style={{ maxWidth: '300px' }}>
                                                    <input
                                                        accept={row.AllowedFileTypes}
                                                        onChange={(event) => {
                                                            const files = Array.from(event.target.files);

                                                            if (row.AllowMultipleFiles) {
                                                                row.SelectedFiles = files;
                                                            } else {
                                                                row.SelectedFile = files.length > 0 ? files[0] : null;
                                                            }
                                                            this.setState(this.state);
                                                        }}
                                                        onClick={(event) => {
                                                            const files = Array.from(event.target.files);

                                                            if (row.AllowMultipleFiles) {
                                                                row.SelectedFiles = files;
                                                            } else {
                                                                row.SelectedFile = files.length > 0 ? files[0] : null;
                                                            }
                                                        }}
                                                        type="file"
                                                        multiple={row.AllowMultipleFiles}  // Allow multiple file selection
                                                    />
                                                    {row.SelectedFiles && row.SelectedFiles.length > 0 && (
                                                        row.SelectedFiles.map((selectedFile, index) => (
                                                            <div key={index} style={{ textAlign: 'left' }}>
                                                                {selectedFile.name}
                                                            </div>
                                                        ))
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center">
                                                No reports available.
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        </div>
                    </Grid>
                    <Grid item xs={1} container
                        direction="column"
                        justifyContent="flex-end"
                        alignItems="flex-end">
                        {this.state.entReports && this.state.entReports.length > 0 && (
                            <Button
                                disabled={this.state.entReports.filter((report) => report && report.SelectedFile === null).length !== 0 || !this.state.year
                                    || !this.state.period}
                                variant="contained"
                                onClick={() => { this.uploadENTFiles(); }}
                            >
                                Submit
                            </Button>
                        )}
                    </Grid>
                </Grid>

                {/*Grid component container*/}

                <div className="ag-theme-alpine" style={{ height: '75vh', width: '100%' }}>

                    <div style={{ height: 10 }} />


                </div>
                <div style={{ height: 80 }} />
            </div>
        );
    }
}
export default withStyles(styles, { withTheme: true })(ENTWizard);